import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path = "repair";

export interface RepairInterface {
  page?: number;
  pageLimit?: number;
}

export interface createRepairInterface {
  branchId: number,
  repairDate: string,
  repairTypeId: number,
  title: string,
  description: string,
  /** "TRUE" | "FALSE" — backend รับเป็น string ไม่ใช่ boolean */
  zoneCheck: string,
  centralCheck: string,
  leaseAgreementId: number | null,
  zoneId: number | null,
  stallId: number | null,
  centralDescription?: string,
  contactPhones?: string[],
  /** ฟิลด์ที่ admin กรอกภายหลังผ่าน PATCH repair/{id} — หน้าแจ้งซ่อมไม่ส่ง */
  repairNo?: string,
  workingId?: number,
  receivedDate?: string,
  succeedDate?: string
}

/** 1 แถวของประวัติการดำเนินงาน จาก GET repair/{id}/status-log */
export interface RepairStatusLogItem {
  logRepairStatusId: number,
  repairStatus: string,
  remark?: string | null,
  createDate: string,
  createName?: string | null
}

/** ไฟล์แนบที่ backend คืนมากับ record — รูปเดียวกับ repair.fileUpload ที่หน้ารายการใช้อยู่ */
export interface RepairFileUpload {
  fileId?: number,
  fileName?: string,
  filePath?: string,
  mimetype?: string,
  /** backend เก็บเป็น string */
  fileSize?: string | number | null
}

/** 1 แถวของ GET repair/additional/list — ไม่มี pagination คืน array ตรงๆ */
export interface RepairAdditionalItem {
  repairAdditionalId: number,
  repairId?: number,
  title?: string | null,
  description?: string | null,
  createDate?: string,
  createName?: string | null,
  fileUpload?: RepairFileUpload[]
}

export interface CreateRepairAdditionalBody {
  repairId: number,
  title?: string,
  description: string
}

export interface UpdateRepairAdditionalBody {
  title?: string,
  description?: string
}

/**
 * POST/PATCH คืน refId ไว้ยิงอัปโหลดไฟล์ต่อ รูปแบบเดียวกับ RepairApi.create / approve
 * receivedDate ไม่ต้องส่ง — backend set ให้ตอนใบหลักเปลี่ยนเป็น RECEIVE
 */
export interface CreateRepairAdditionalResponse {
  refId: number,
  fileType: string,
  repairAdditionalId?: number
}

interface ApproveRepairInterface {
  repairId: number,
  approveDate: string,
  sequential: number,
  refUserId: number
}
interface UpdateRepairInterface {
  repairDate: string,
  remark: string,
  status: string
}

export interface GetRepairListParams {
  sortType?: string;
  sortBy?: string;
  search?: string;
  status?: string;
  userId?: number;
  branchId?: number;
  zoneId?: number | null;
  stallId?: number | null;
}

export default class RepairApi extends BaseAPI {
  static findAll(params: RepairInterface): Promise<any> {
    return this.api.get(path, { params: { ...params } }).then((res) => res);
  }

  static create(params: createRepairInterface): Promise<any> {
    return this.api.post(path, { ...params })
  }

  static approve(params: ApproveRepairInterface): Promise<any> {
    return this.api.post(`${path}/approve`, { ...params })
  }

  static updateStatus(id: number, body: { status: string | null, remark?: string | null }): Promise<AxiosResponse<any>> {
    return this.api.patch(`${path}/${id}/status`, body)
  }

  static update(id: number, props: UpdateRepairInterface): Promise<any> {
    return this.api.patch(`${path}/${id}`, { ...props })
  }
  static delete(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`)
  }


  /** axios 0.22 ประกาศ AxiosResponse<T = never> ถ้าไม่ใส่ generic res.data จะเป็น never */
  static statusLog(id: number): Promise<AxiosResponse<RepairStatusLogItem[]>> {
    return this.api.get(`${path}/${id}/status-log`)
  }
  /**
   * เรื่องเพิ่มเติมของใบซ่อม — 1 ใบหลักมีได้หลายเรื่อง
   * backend เป็นฝ่ายดึงใบหลักกลับเป็นสถานะ ADDITIONAL เอง ฝั่งนี้ไม่ต้องเรียก updateStatus ต่อ
   */
  static additionalCreate(body: CreateRepairAdditionalBody): Promise<AxiosResponse<CreateRepairAdditionalResponse>> {
    return this.api.post(`${path}/additional`, body)
  }

  static additionalList(repairId: number): Promise<AxiosResponse<RepairAdditionalItem[]>> {
    return this.api.get(`${path}/additional/list`, { params: { repairId } })
  }

  static additionalFindOne(repairAdditionalId: number): Promise<AxiosResponse<RepairAdditionalItem>> {
    return this.api.get(`${path}/additional/${repairAdditionalId}`)
  }

  static additionalUpdate(repairAdditionalId: number, body: UpdateRepairAdditionalBody): Promise<AxiosResponse<RepairAdditionalItem>> {
    return this.api.patch(`${path}/additional/${repairAdditionalId}`, body)
  }

  /** soft delete */
  static additionalDelete(repairAdditionalId: number): Promise<AxiosResponse<any>> {
    return this.api.delete(`${path}/additional/${repairAdditionalId}`)
  }

  static report_data(params: GetRepairListParams): Promise<AxiosResponse<any>> {
    return this.api.get(`${path}/export`, { params, responseType: 'arraybuffer' })
  }
}
